<script>
import { browser } from '$app/environment';
import { onMount, onDestroy } from 'svelte';
import logo from '$lib/images/logo.png';
import { PUBLIC_SHOPIFY_API_TOKEN } from '$env/static/public';
import { page } from '$app/stores';  
import { getHref } from '$lib/storyblok';

// Move the subscription code inside this component
let currentPage;
const unsubscribe = page.subscribe(value => {
  currentPage = value;
});

const invertColor = ['ShopOverzichtPagina', 'VacatureOverzichtPagina'];

export let algemeen;
//export let activeSlug;
let menuIsOpen = false;
let menuSticky = false;

function handleScroll (event) {  
  if(window.scrollY > 100) {
      menuSticky = true;
  }else {
      menuSticky = false;
  }
}

function toggleMenu() {
  var html = document.getElementsByTagName("html");

  html[0].classList.toggle("open-menu");

  menuIsOpen = !menuIsOpen;
}

function openSubMenu(event) {
  event.target.classList.add("hover");
}

function closeSubMenu() {
  var collectionArray = [];
  var collection = document.getElementsByClassName('hover');
  
  for (let i = 0; i < collection.length; i++) {
    collectionArray.push(collection[i])
  }
  
  collectionArray.forEach(element => element.classList.remove("hover"));
}

function menuResize() {
  var menuplaceholder = document.getElementById("menu-placeholder");
  var fullMenu = document.getElementById("full-menu");
  var menubarHeight = fullMenu.offsetHeight;
  
  var placeholderHeight = menubarHeight;
  
  menuplaceholder.style.height = placeholderHeight + 'px';
}

onMount(async () => {  
  menuResize();
});

// Remember to unsubscribe when this component is destroyed
onDestroy(() => {
  unsubscribe();
});

</script>
<svelte:window on:scroll={handleScroll} on:resize={menuResize} />
<div class="full-menu-holder {menuSticky?'sticky':''}"  id="full-menu" class:invert-color={currentPage.data.story?.content.component ? invertColor.includes(currentPage.data.story?.content.component) : true}>
  {#if algemeen.content.toon_top_menu}
  <div class="topmenu" id="topmenu">
    <div class="topmenu-holder">
      {#if algemeen.content.topmenu}
      <ul>
        {#each algemeen.content.topmenu as item}
        <li>
          {#if item.link.target == "_blank"}
          <a href={getHref(item.link)} target="_blank" >{item.naam}</a>
          {:else}
          <a href={getHref(item.link)} >{item.naam}</a>
          {/if}
        </li>
        {/each}
      </ul>
      {/if}
    </div>
    {#if algemeen.content.emailadres || algemeen.content.telefoonnummer}
    <div class="contact-info-holder">
      {#if algemeen.content.telefoonnummer}
      <div class="contact-info">
        <div class="icon-holder">
          <svg width="16px" height="22px" viewBox="0 0 16 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Ontwerp-Pluzpunt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Homepage---Ficare" transform="translate(-1260.000000, -14.000000)">
                      <g id="Group-11" transform="translate(1261.000000, 15.000000)">
                          <g id="smartphone-(1)" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.66666667">
                              <g id="Group-10">
                                  <rect id="Rectangle" x="0" y="0" width="14" height="20" rx="1.66666667"></rect>
                              </g>
                          </g>
                          <rect id="Rectangle" fill="#fff" x="6" y="15" width="2" height="2" rx="1"></rect>
                      </g>
                  </g>
              </g>
          </svg>
        </div>
        <a href="tel:{algemeen.content.telefoonnummer}">{algemeen.content.telefoonnummer}</a>
      </div>
      {/if}
      {#if algemeen.content.emailadres}
      <div class="contact-info">
        <div class="icon-holder">
          <svg width="19px" height="16px" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Ontwerp-Pluzpunt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
                  <g id="Homepage---Ficare" transform="translate(-1415.000000, -18.000000)" stroke="#fff" stroke-width="1.66666667">
                      <g id="mail-(1)" transform="translate(1416.000000, 19.000000)">
                          <path d="M1.66666667,0 L15,0 C15.9166667,0 16.6666667,0.75 16.6666667,1.66666667 L16.6666667,11.6666667 C16.6666667,12.5833333 15.9166667,13.3333333 15,13.3333333 L1.66666667,13.3333333 C0.75,13.3333333 0,12.5833333 0,11.6666667 L0,1.66666667 C0,0.75 0.75,0 1.66666667,0 Z" id="Path" stroke-linecap="round"></path>
                          <polyline id="Path" points="16.6666667 1.66666667 8.33333333 7.5 0 1.66666667"></polyline>
                      </g>
                  </g>
              </g>
          </svg>
        </div>
        <a href="mailto:{algemeen.content.emailadres}">{algemeen.content.emailadres}</a>
      </div>
      {/if}
    </div>
    {/if}
  </div>
  {/if}
  <div class="menu-bar" id="menu-bar">
    <div class="menu-inner">
      <div class="logo-holder">
        <a data-sveltekit-preload-data="tap" href="/">
          <img src={logo} alt="" quality="100" />
        </a>
      </div>
      <div class="menu-right flex align-middle">
        {#if PUBLIC_SHOPIFY_API_TOKEN }
          <div class="card-holder">
            <div class="flex justify-end mr-[30px]">
                <div class="relative">
                  <div class="counter-holder">
                    <p class="flex h-[23px] w-[23px] items-center justify-center rounded-full text-xs">3</p>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file: h-[31px] w--[31px]">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                  </svg>
              </div>
            </div>
          </div>
        {/if}
        <div class="menu-toggle-holder" on:click={toggleMenu}>
          <span>Menu</span>
          <div class="hamburger">
            <span class="line top"></span>
            <span class="line middle"></span>
            <span class="line bottom"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="menu-placeholder"></div>

<div id="menu" class={menuIsOpen?'open':''} on:mouseleave={closeSubMenu} role="presentation">
  <ul>
    {#each algemeen.content.hoofdmenu as item}
    <li class={item.submenu.length?'has-sub':''} >
      <div on:mouseenter={openSubMenu} role="presentation">
        {#if item.link.target == "_blank"}
        <a href={getHref(item.link)} target="_blank" on:click={toggleMenu}>{item.naam}</a>
        {:else}
        <a href={getHref(item.link)} on:click={toggleMenu}>{item.naam}</a>
        {/if}
        {#if item.submenu.length}
        <span class="menu-arrow" >
          <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Template-4" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
              <g id="5-Menu" transform="translate(-1457.000000, -345.000000)" stroke="#FFFFFF" stroke-width="2">
                <g id="arrow-right" transform="translate(1465.000000, 353.000000) scale(1, -1) rotate(-90.000000) translate(-1465.000000, -353.000000) translate(1458.000000, 346.000000)">
                  <line x1="0" y1="7" x2="14" y2="7" id="Path"></line>
                  <polyline id="Path" points="7 0 14 7 7 14"></polyline>
                </g>
              </g>
            </g>
          </svg>
        </span>
        <ul class="submenu">
          {#each item.submenu as subitem}
          <li>
            {#if subitem.link.target == "_blank"}
            <a href={getHref(subitem.link)} target="_blank" on:click={toggleMenu}>{subitem.naam}</a>
            {:else}
            <a href={getHref(subitem.link)} on:click={toggleMenu}>{subitem.naam}</a>
            {/if}
          </li>
          {/each}
        </ul>
        {/if}
      </div>
    </li>
    {/each}
  </ul>
</div>
<div id="backdrop" class={menuIsOpen?'open':''} on:click={toggleMenu} on:keypress={toggleMenu} role="presentation"></div>
<style lang="postcss">
    html.open-menu {
      .topmenu {
        transform: translateY(-100%);
      }
      
      .menu-bar {
        
        .menu-toggle-holder {
          .hamburger .line {
            &.top {
              top: 9px;
              transform: rotate(-45deg);
            }
            
            &.middle {
              left: 50%;
              width: 0;
            }
            
            &.bottom {
              bottom: 9px;
              transform: rotate(45deg);
            }
          }
        }
        
        .logo-holder {
          opacity: 0;
          visibility: hidden;
        }
      }
      
      .sticky .menu-bar .logo-holder {
        opacity: 1;
        visibility: visible;
      }

      /* #menu {
        right: 0;
        padding: 200px;
      } */

      .full-menu-holder.invert-color {
        .menu-toggle-holder {
          color: var(--menu-color);

          .hamburger .line {
            background-color: var(--menu-color);
          }
        }
      }
    }
    
    .full-menu-holder {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 100;
    }

    .full-menu-holder.sticky .menu-toggle-holder {
      color: var(--sticky-menu-color);
    }

    .full-menu-holder.sticky .hamburger .line {
      background-color: var(--sticky-menu-color);
    }

    .full-menu-holder.sticky .topmenu {
      height: 0;
      padding: 0 40px;
      overflow: hidden;
    }

    .menu-bar {
      position: relative;
      margin: 0;
      padding: 12px 40px;
      width: 100%;
      z-index: 100;
      box-sizing: border-box;
      transition: all .4s;
      
      .logo-holder {
        transition: all .4s;
      }
    }
    
    .sticky .menu-bar {
        background-color: var(--sticky-menu-background);
        padding: 12px 40px;
    }
    
    .topmenu {
      background-color: var(--topmenu-background);
      padding: 10px 40px;
      transition: all .4s;
      position: relative;
      z-index: 10;
      display: flex;
      justify-content: space-between;
      
      .contact-info {
        font-size: 15px;
        display: inline-block;
        
        &:not(:last-child) {
          margin-right: 20px;
        }
        
        .icon-holder {
          display: inline-block;
          text-align: center;
          margin-right: 10px;
          transform: translateY(4px);
          
          svg g {
            stroke: var(--topmenu-color);
          }
        }
          
        a {
          color: var(--topmenu-color);
        }
      }
    }
    
    #menu-placeholder {
      display: block;
    }
    
    .menu-inner {
      display: flex;
      justify-content: space-between;
    }
    
    .menu-toggle-holder {
      display: flex;
      align-items: center;
      color: var(--menu-color);
      transition: all .4s;
      cursor: pointer;
    }
    
    .menu-toggle-holder .hamburger {
      display: inline-block;
      position: relative;
      width: 34px;
      height: 21px;
      margin-left: 20px;
      
      .line {
        position: absolute;
        height: 3px;
        background-color: var(--menu-color);
        display: block;
        width: inherit;
        transition: all .4s;
        left: 0;
        
        &.top {
          top: 0;
        }
        
        &.middle {
          top: 9px;
        }
        
        &.bottom {
          bottom: 0;
        }
      }
    }
    
    #menu {
      margin: 0;
      position: fixed;
      height: 100vh;
      padding: 200px 100px 20px;
      background-color: var(--menu-background);
      color: var(--menu-color);
      top: 0;
      right: -200vw;
      width: 100%;
      max-width: 750px;
      box-sizing: border-box;
      transition: all .4s;
      transition-delay: .2s;
      z-index: 50;
      overflow: scroll;
      
      &.open {
        right: 0vw;
      }
      
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        
        li {
          display: block;
          vertical-align: middle;
          position: relative;
          transition: all .2s ease;
          margin-bottom: 10px;
          
          a {
            text-decoration: none!important;
            font-family: var(--heading-font);
            font-weight: 600;
          }
        }
      }
      
      > ul > li > div > a {
        font-size: 40px;
        line-height: 54px;
        color: var(--menu-color);
        transition: all .4s;
        
        &:hover {
          color: var(--menu-hover-color);
        }
      }
      
      .menu-arrow {
        margin-left: 15px;
        display: inline-block;
        margin-bottom: 4px;
        
        svg {
          transition: all .4s;
        }
      }
      
      .submenu {
        visibility: hidden;
        opacity: 0;
        transition: all .3s;
        position: relative;
        width: 100%;
        text-align: left;
        padding: 0 30px;
        margin: 0;
        min-width: 250px;
        z-index: 1000;
        height: 0;
        
        > li {
          margin-bottom: 10px;
          margin-left: 0!important;
          line-height: 20px;
          
          > a {
            color: var(--menu-color);
            font-size: 25px;
            line-height: 30px;
            margin-bottom: 15px;
            position: relative;
            
            &::before {
              content: '';
              height: 2px;
              width: 0;
              transition: all .3s;
              bottom: 0;
              position: absolute;
              left: 0;
              background-color: var(--menu-color);
            }
            
            &:hover {
              &::before {
                width: 100%;
              }
            }
          }
        }
      }
      
      .has-sub {
        display: flex;
        
        > div {
          display: inline-block;
        }
        .hover {
          .menu-arrow svg {
            transform: rotate(180deg);
          }
          
          .submenu {
            visibility: visible;
            opacity: 1;
            height: auto;
            padding: 20px 30px 10px;
          }
        }
      }
    }
    
    #backdrop {
      background-color: var(--black);
      opacity: .8;
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 100%;
      bottom: 0;
      z-index: 10;
      transition: all .4s;
      
      &.open {
        left: 0;
      }
    }
    
    .topmenu {
      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        
        li {
          display: inline-block;
          margin-right: 15px;
          
          a {
            color: var(--topmenu-color);
          }
        }
      }
    }

    .full-menu-holder.invert-color {
      .menu-toggle-holder {
        color: var(--menu-background);

        .hamburger .line {
          background-color: var(--menu-background);
        }
      }
    }

    .card-holder .counter-holder {
      position: absolute;
      top: -10px;
      right: -10px;

      svg {
        stroke: var(--card-background);
      }

      p {
        background-color: var(--card-counter-background);
        color: var(--card-counter-color);
      }
    }

    html.open-menu .full-menu-holder.sticky .menu-toggle-holder {
      color: var(--sticky-menu-color);
        
      .hamburger .line {
        background-color: var(--sticky-menu-color);
      }
    }
    
    @media only screen and (max-width: 1600px) {
      #menu {
        max-width: 545px;
      }
    }

    @media only screen and (max-width: 1260px) {
      .menu-bar .logo-holder {
        max-width: 90px;
      }
    }
    
    @media only screen and (max-width: 1200px) {
      #menu {
        padding: 150px 60px 20px;
      }
    }
    
    @media only screen and (max-width: 1100px) {
      #menu > ul > li > div > a {
        font-size: 36px;
        line-height: 42px;
      }
      
      #menu .submenu > li > a {
        font-size: 24px;
        line-height: 30px;
      }
      
      .topmenu {
        display: none;
      }
    }
    
    @media only screen and (max-width: 767px) {
      #menu {
        max-width: 100vw;
        padding: 150px 40px 20px;
      }
      
      #menu > ul > li > div > a {
        font-size: 28px;
        line-height: 36px;
      }
      
      #menu .submenu > li > a {
        font-size: 22px;
        line-height: 28px;
      }
    
      html.open-menu .menu-bar .logo-holder {
        opacity: 1;
        visibility: visible;
      }
      
      .menu-bar {
        padding: 20px 20px;
        background-color: var(--sticky-menu-background);
        
        .logo-holder {
          max-width: 60px;
        }
      }
    
      .sticky .menu-bar {
        padding: 20px 20px;
      }
    
      #menu {
        padding: 110px 20px 20px;
      }
      
      html.open-menu .full-menu-holder.invert-color .menu-toggle-holder, .menu-toggle-holder {
        color: var(--sticky-menu-color);
        
        .hamburger .line {
          background-color: var(--sticky-menu-color);
        }
      }

      .card-holder {
        .counter-holder p {
          height: 20px;
          width: 20px;
          font-size: 11px;
        }

        svg {
          height: 25px;
        }
      }

      #menu .menu-arrow {
        margin-left: 10px;
        margin-bottom: 2px;
      }
    }
</style>